import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedLeftIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.02 21.28L4.66 14.92L11.02 8.56L12.3 9.84L8.12 13.96H12.96C14.84 13.96 16.34 12.4 16.34 10.46V4.92H18.34V10.46C18.34 13.52 16.02 15.88 12.96 15.88H8.12L12.3 20L11.02 21.28Z" />
    </SvgIcon>
  );
});
